<template>
	<div class="broker-tours-widget">
		<div class="broker-tours-widget__header">
			<h3 class="broker-tours-widget__title">Recent Tours</h3>
			<a href="/tours" class="broker-tours-widget__view-all">View All</a>
		</div>
		
		<div v-if="tours.length === 0" class="broker-tours-widget__empty">
			<svg class="broker-tours-widget__empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
				<path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
			</svg>
			<p class="broker-tours-widget__empty-text">No tours scheduled</p>
		</div>
		
		<div v-else class="broker-tours-widget__list">
			<div 
				v-for="tour in recentTours" 
				:key="tour.id"
				class="broker-tours-widget__item"
				@click="viewTour(tour)"
			>
				<div class="broker-tours-widget__item-header">
					<h4 class="broker-tours-widget__item-title">{{ tour.name }}</h4>
					<span 
						class="broker-tours-widget__status"
						:class="`broker-tours-widget__status--${tour.status}`"
					>
						{{ formatStatus(tour.status) }}
					</span>
				</div>
				
				<div class="broker-tours-widget__item-details">
					<div class="broker-tours-widget__detail">
						<svg class="broker-tours-widget__icon" viewBox="0 0 20 20" fill="currentColor">
							<path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd" />
						</svg>
						<span>{{ formatDate(tour.date) }}</span>
					</div>
					
					<div class="broker-tours-widget__detail">
						<svg class="broker-tours-widget__icon" viewBox="0 0 20 20" fill="currentColor">
							<path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
						</svg>
						<span>{{ getAttendeeCount(tour) }} attendees</span>
					</div>
					
					<div v-if="tour.project" class="broker-tours-widget__detail">
						<svg class="broker-tours-widget__icon" viewBox="0 0 20 20" fill="currentColor">
							<path fill-rule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clip-rule="evenodd" />
						</svg>
						<span>{{ tour.project.name }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	name: 'BrokerToursWidget',
	
	props: {
		tours: {
			type: Array,
			default: () => []
		}
	},
	
	computed: {
		recentTours() {
			// Show up to 5 most recent tours, sorted by date descending
			return this.tours
				.slice()
				.sort((a, b) => {
					const dateA = a.date ? moment(a.date) : moment(0);
					const dateB = b.date ? moment(b.date) : moment(0);
					return dateB.diff(dateA);
				})
				.slice(0, 5);
		}
	},
	
	methods: {
		formatDate(date) {
			if (!date) return 'No date set';
			return moment(date).format('MMM D, YYYY h:mm A');
		},
		
		formatStatus(status) {
			if (!status) return 'Draft';
			return status.charAt(0).toUpperCase() + status.slice(1);
		},
		
		getAttendeeCount(tour) {
			if (!tour.attendees) return 0;
			return tour.attendees.length;
		},
		
		viewTour(tour) {
			if (tour.project_id) {
				window.location.href = `/projects/${tour.project_id}?tab=tours`;
			}
		}
	}
}
</script>
